import React, { useState, useRef, useEffect } from 'react'
import DataTable from '../../../Components/DataTable/DataTable';
import { Button, Modal, FormGroup, Form, Label, Input, ModalBody, Row, Col } from 'reactstrap';
import "../../pages.css"
import Header from '../../../Layout/Admin/Header';
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { enGB, srLatn } from "date-fns/locale";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { format } from "date-fns";
import RegularModal from "../../../Components/Modals/RegularReservationModal";
import EditModal from "../../../Components/Modals/EditReservationModal";
import EmailReportModal from '../../../Components/Modals/EmailReportModal';
import withAuth from "../../../Components/CheckSessionStorage/sessionUtils";
import apiRequest from '../../../api';
const AdminHistory = () => {
  const selectedLanguageRef = useRef(localStorage.getItem('Language'));

  const columns_en = [
    { title: 'Username', key: "username" },
    { title: 'Parking lot', key: "lot" },
    { title: 'Time slot', key: "startDate" }
  ];

  const columns_rs = [
    { title: 'Korisničko ime', key: "username" },
    { title: 'Parking', key: "lot" },
    { title: 'Vreme', key: "startDate" }
  ];

  const [columns, setColumns] = useState(() => {
    return (selectedLanguageRef.current === "EN" ? columns_en : columns_rs);
  });

  useEffect(() => {
    // Handle changes from other tabs/windows and local changes
    const handleLanguageChange = (event) => {
      selectedLanguageRef.current = event.detail['selectedLanguage'];
      setColumns(selectedLanguageRef.current === "EN" ? columns_en : columns_rs)
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  const locale = selectedLanguageRef.current === 'RS' ? srLatn : enGB;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // To manage loading state
  const [error, setError] = useState(null); // To manage error state

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [editModal, setEditModal] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [emailReportModal, setEmailReportModal] = useState(false);
  const calendarRef = useRef(null);


  const [filterText, setFilterText] = useState(""); // State to store the input value
  const [filteredData, setFilteredData] = useState([]); // State to store filtered results


  // Function to handle input change
  const handleFilterChange = (e) => {
    const value = e.target.value.toLowerCase(); // Convert input to lowercase for case-insensitive filtering
    setFilterText(value);
    // Filter data based on the input value
    filterData(value, data);    
  };

  const filterData = ( value, data ) => {
    const filtered = data.filter((item) =>
      item.username.toLowerCase().startsWith(value) // Filter by 'username' starting with the input
    );
    setFilteredData(filtered);
  };


  const handleSelect = (date) => {
    setSelectedDate(date);
    setIsCalendarOpen(false); // Close the calendar after selecting a date
    fetchReservations(date);
  };

  const toggleModal = (e) => {
    e.preventDefault()
    setModalOpen(!modalOpen)
  };
  const [selectedRow, setSelectedRow] = useState({
    start_time: new Date(),
    end_time: new Date(),
    name: "",
    username: "",
    company: "",
    notes: "",
    id: "",
  });
  const toggleEditModal = (row) => {
    if (editModal === true) {
      // Close modal, no need for additional action when closing
      setEditModal(false);
    } else {
      setSelectedRow({
        start_time: row.startDate,
        end_time: row.endDate,
        name: row.name,
        username: row.username,
        company: row.company,
        notes: row.notes,
        id: row.id,
      });
      setEditModal(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) // Check if click is outside
      ) {
        setIsCalendarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const fetchReservations = async (date = selectedDate) => {
    console.log("Usao u fetch");
    const formatDateToLocal = (date) => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
      const day = date.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${day}`;
    };
    try {
      // Retrieve JWT from localStorage
      const token = sessionStorage.getItem("jwt");
      const formattedDate = formatDateToLocal(date);
      const reservations = await apiRequest(`/api/reservations/get_all_reservations?date=${formattedDate}`, 'GET', null, token);

      const formattedData = reservations.map((reservation) => {
        const startDate = new Date(reservation.startTime);
        const endDate = new Date(reservation.endTime);

        return {
          username: reservation.username,
          name: reservation.name,
          lot: reservation.parkingLot,
          startDate: startDate,
          endDate: endDate,
          id: reservation.reservationCode,
          company: reservation.company,
          notes: reservation.notes,
        };
      });
      const sortedData = [...formattedData].sort((a, b) => a.startDate - b.startDate);
      setData(sortedData);
      filterData(filterText ,sortedData);
      //console.log("Data:", sortedData);
    } catch (err) {
      setError(err.message);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loading
      await fetchReservations(); // Fetch data
      setLoading(false); // Stop loading
    };

    fetchData();
  }, []); // Runs only once when the component is mounted
  

  if (loading) {
    return <Header />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <React.Fragment>
      <Header />

      <div className='container  ' >
        <div className='table-container-1' >
          <Row className="my-3 d-flex align-items-center justify-content-between">
            <Col xs="6" md="4" className="d-flex align-items-center">
              <div className="form-group position-relative date_input" ref={calendarRef}>
                <img
                  src="/assets/icons/calendarDay.svg"
                  alt="Calendar Icon"
                  className="calendar-icon"
                />
                <input
                  type="text"
                  className="form-control custom-input"
                  value={format(selectedDate, "dd.MM.yyyy")}
                  onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                  readOnly
                  style={{ cursor: "pointer" }}
                />
                {isCalendarOpen && (
                  <Calendar
                    date={selectedDate}
                    onChange={handleSelect}
                    locale={locale}
                    color="#3d91ff"
                    className="calendar-container"
                  />
                )}
              </div>
            </Col>
            <Col xs="6" md="8" className="d-flex align-items-center justify-content-end">
              <div className="form-group position-relative filter_input">
                <img
                  src="/assets/icons/search.svg"
                  alt="Calendar Icon"
                  className="calendar-icon"
                />
                <input
                  name="filter"
                  type="text"
                  className="form-control custom-input"
                  placeholder={selectedLanguageRef.current === 'EN' ? "Filter Users..." : "Pretraga Korisnika..."}
                  style={{ width: "100%" }}
                  value={filterText}
                  onChange={handleFilterChange}
                />
              </div>
            </Col>
          </Row>
          <div className='row' style={{  justifyContent: "center", position: "relative" }} >
            <DataTable onEdit={(row) => toggleEditModal(row)} data={filteredData} fetchReservations={() => fetchReservations()} columns={columns}  />
          </div>
          <div className='row justify-content-start align-items-center my-3'>
            <div className='col-6 text-start'>
              <div className='col-6 text-start'>
                <Button style={{
                  background: "transparent",
                  border: "none", // Corrected typo here                  
                  cursor: "pointer", // Optional: Add a pointer cursor for better UX
                }} onClick={() => setEmailReportModal(!emailReportModal)}>
                  <span className="material-icons">ios_share</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
        {/* <div className='row justify-content-center justify-content-md-end my-3 ' >
          <div className='col-12 text-end ' >

          <Button className='show-btn' onClick={handleShowMore} >{visibleRows >= data.length ? "Show less" : "show more"}</Button>
          </div>
        </div> */}
      </div>
      <RegularModal
        isOpen={modalOpen}
        toggle={toggleModal}
        fetchReservations={fetchReservations}
        selectedDate={selectedDate}
      />

      <EditModal
        isOpen={editModal}
        toggle={toggleEditModal}
        selectedRow={selectedRow}
        fetchReservations={fetchReservations}
      />
      <EmailReportModal
        isOpen={emailReportModal}
        toggle={() => setEmailReportModal(!emailReportModal)}
      />
    </React.Fragment>
  )
}

export default withAuth(AdminHistory);